import { t as e } from "./ConfigurationDetail-D_i_kbRs.js";
import { createRoute as t, lazyRouteComponent as n, redirect as r } from "@tanstack/react-router";
import { createElement as i } from "react";
//#region src/vite-plugin/routes.ts
function a(e) {
	return [
		{
			filePath: "index.tsx",
			routeSuffix: "/",
			lazy: !1,
			staticData: { title: "Configurations" },
			redirect: {
				to: `${e}/general`,
				params: "{ id: params.id }"
			}
		},
		{
			filePath: "general.tsx",
			routeSuffix: "/general",
			lazy: !1,
			staticData: { title: "General" }
		},
		{
			filePath: "general.lazy.tsx",
			routeSuffix: "/general",
			lazy: !0,
			componentName: "ConfigurationDetailGeneral"
		},
		{
			filePath: "variables.tsx",
			routeSuffix: "/variables",
			lazy: !1,
			staticData: { title: "Variables" }
		},
		{
			filePath: "variables.lazy.tsx",
			routeSuffix: "/variables",
			lazy: !0,
			componentName: "ConfigurationDetailVariables"
		},
		{
			filePath: "cloud-manager.tsx",
			routeSuffix: "/cloud-manager",
			lazy: !1,
			staticData: { title: "Cloud Manager" }
		},
		{
			filePath: "cloud-manager.lazy.tsx",
			routeSuffix: "/cloud-manager",
			lazy: !0,
			componentName: "ConfigurationDetailCloudManager"
		},
		{
			filePath: "ads-router/index.tsx",
			routeSuffix: "/ads-router/",
			lazy: !1,
			staticData: { title: "ADS Router" }
		},
		{
			filePath: "ads-router/index.lazy.tsx",
			routeSuffix: "/ads-router/",
			lazy: !0,
			componentName: "ConfigurationDetailAdsRouter"
		},
		{
			filePath: "analytics/_layout.tsx",
			routeSuffix: "/analytics",
			lazy: !1,
			staticData: { title: "Analytics" }
		},
		{
			filePath: "analytics/_layout.lazy.tsx",
			routeSuffix: "/analytics",
			lazy: !0,
			componentName: "ConfigurationDetailAnalytics"
		},
		{
			filePath: "analytics/index.tsx",
			routeSuffix: "/analytics/",
			lazy: !1,
			redirect: {
				to: `${e}/analytics/settings`,
				params: "{ id: params.id }"
			}
		},
		{
			filePath: "analytics/settings.tsx",
			routeSuffix: "/analytics/settings",
			lazy: !1,
			staticData: { title: "Settings" }
		},
		{
			filePath: "analytics/settings.lazy.tsx",
			routeSuffix: "/analytics/settings",
			lazy: !0,
			componentName: "AnalyticsSettings"
		},
		{
			filePath: "analytics/triggers.tsx",
			routeSuffix: "/analytics/triggers",
			lazy: !1,
			staticData: { title: "Triggers" }
		},
		{
			filePath: "analytics/triggers.lazy.tsx",
			routeSuffix: "/analytics/triggers",
			lazy: !0,
			componentName: "AnalyticsTriggers"
		},
		{
			filePath: "collector/_layout.tsx",
			routeSuffix: "/collector",
			lazy: !1,
			staticData: { title: "Collector" }
		},
		{
			filePath: "collector/_layout.lazy.tsx",
			routeSuffix: "/collector",
			lazy: !0,
			componentName: "CollectorLayout"
		},
		{
			filePath: "collector/index.tsx",
			routeSuffix: "/collector/",
			lazy: !1,
			redirect: {
				to: `${e}/collector/connections`,
				params: "{ id: params.id }"
			}
		},
		{
			filePath: "collector/settings.tsx",
			routeSuffix: "/collector/settings",
			lazy: !1,
			staticData: { title: "Settings" }
		},
		{
			filePath: "collector/settings.lazy.tsx",
			routeSuffix: "/collector/settings",
			lazy: !0,
			componentName: "CollectorSettings"
		},
		{
			filePath: "collector/connections/index.tsx",
			routeSuffix: "/collector/connections/",
			lazy: !1,
			staticData: { title: "Connections" }
		},
		{
			filePath: "collector/connections/index.lazy.tsx",
			routeSuffix: "/collector/connections/",
			lazy: !0,
			componentName: "ConnectionsOverview"
		},
		{
			filePath: "collector/connections/$connectionId/_layout.tsx",
			routeSuffix: "/collector/connections/$connectionId",
			lazy: !1,
			staticData: { title: "Connection" }
		},
		{
			filePath: "collector/connections/$connectionId/_layout.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId",
			lazy: !0,
			componentName: "ConfigurationConnectionDetail"
		},
		{
			filePath: "collector/connections/$connectionId/index.tsx",
			routeSuffix: "/collector/connections/$connectionId/",
			lazy: !1,
			redirect: {
				to: `${e}/collector/connections/$connectionId/configuration`,
				params: "{ id: params.id, connectionId: params.connectionId }"
			}
		},
		{
			filePath: "collector/connections/$connectionId/configuration.tsx",
			routeSuffix: "/collector/connections/$connectionId/configuration",
			lazy: !1,
			staticData: { title: "Configuration" }
		},
		{
			filePath: "collector/connections/$connectionId/configuration.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/configuration",
			lazy: !0,
			componentName: "ConnectionConfiguration"
		},
		{
			filePath: "collector/connections/$connectionId/custom-settings.tsx",
			routeSuffix: "/collector/connections/$connectionId/custom-settings",
			lazy: !1,
			staticData: { title: "Custom Settings" }
		},
		{
			filePath: "collector/connections/$connectionId/custom-settings.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/custom-settings",
			lazy: !0,
			componentName: "ConnectionCustomSettings"
		},
		{
			filePath: "collector/connections/$connectionId/measurements/_layout.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements",
			lazy: !1,
			staticData: { title: "Measurements" }
		},
		{
			filePath: "collector/connections/$connectionId/measurements/_layout.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements",
			lazy: !0,
			componentName: "ConnectionMeasurementsLayout"
		},
		{
			filePath: "collector/connections/$connectionId/measurements/index.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/",
			lazy: !1,
			staticData: { title: "Measurements" }
		},
		{
			filePath: "collector/connections/$connectionId/measurements/index.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/",
			lazy: !0,
			componentName: "ConnectionMeasurementsIndexRedirect"
		},
		{
			filePath: "collector/connections/$connectionId/measurements/$measurementIndex/_layout.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/$measurementIndex",
			lazy: !1,
			staticData: { title: "Measurement" }
		},
		{
			filePath: "collector/connections/$connectionId/measurements/$measurementIndex/_layout.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/$measurementIndex",
			lazy: !0,
			componentName: "ConnectionMeasurementsContentLayout"
		},
		{
			filePath: "collector/connections/$connectionId/measurements/$measurementIndex/index.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/$measurementIndex/",
			lazy: !1,
			redirect: {
				to: `${e}/collector/connections/$connectionId/measurements/$measurementIndex/variables`,
				params: "{ id: params.id, connectionId: params.connectionId, measurementIndex: params.measurementIndex }"
			}
		},
		{
			filePath: "collector/connections/$connectionId/measurements/$measurementIndex/configuration.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/$measurementIndex/configuration",
			lazy: !1,
			staticData: { title: "Configuration" }
		},
		{
			filePath: "collector/connections/$connectionId/measurements/$measurementIndex/configuration.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/$measurementIndex/configuration",
			lazy: !0,
			componentName: "ConnectionMeasurementConfiguration"
		},
		{
			filePath: "collector/connections/$connectionId/measurements/$measurementIndex/variables.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/$measurementIndex/variables",
			lazy: !1,
			staticData: { title: "Variables" }
		},
		{
			filePath: "collector/connections/$connectionId/measurements/$measurementIndex/variables.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/$measurementIndex/variables",
			lazy: !0,
			componentName: "ConnectionMeasurementVariables"
		},
		{
			filePath: "collector/connections/$connectionId/measurements/$measurementIndex/custom-settings.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/$measurementIndex/custom-settings",
			lazy: !1,
			staticData: { title: "Custom Settings" }
		},
		{
			filePath: "collector/connections/$connectionId/measurements/$measurementIndex/custom-settings.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/measurements/$measurementIndex/custom-settings",
			lazy: !0,
			componentName: "ConnectionMeasurementCustomSettings"
		},
		{
			filePath: "collector/connections/$connectionId/tags/_layout.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags",
			lazy: !1,
			staticData: { title: "Tags" }
		},
		{
			filePath: "collector/connections/$connectionId/tags/_layout.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags",
			lazy: !0,
			componentName: "ConfigurationConnectionTagsLayout"
		},
		{
			filePath: "collector/connections/$connectionId/tags/index.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/",
			lazy: !1,
			staticData: { title: "Tags" }
		},
		{
			filePath: "collector/connections/$connectionId/tags/index.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/",
			lazy: !0,
			componentName: "ConnectionTagsIndexRedirect"
		},
		{
			filePath: "collector/connections/$connectionId/tags/$tagIndex/_layout.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/$tagIndex",
			lazy: !1,
			staticData: { title: "Tag" }
		},
		{
			filePath: "collector/connections/$connectionId/tags/$tagIndex/_layout.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/$tagIndex",
			lazy: !0,
			componentName: "ConfigurationConnectionTagsContentLayout"
		},
		{
			filePath: "collector/connections/$connectionId/tags/$tagIndex/index.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/$tagIndex/",
			lazy: !1,
			redirect: {
				to: `${e}/collector/connections/$connectionId/tags/$tagIndex/configuration`,
				params: "{ id: params.id, connectionId: params.connectionId, tagIndex: params.tagIndex }"
			}
		},
		{
			filePath: "collector/connections/$connectionId/tags/$tagIndex/configuration.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/$tagIndex/configuration",
			lazy: !1,
			staticData: { title: "Configuration" }
		},
		{
			filePath: "collector/connections/$connectionId/tags/$tagIndex/configuration.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/$tagIndex/configuration",
			lazy: !0,
			componentName: "ConnectionTagConfiguration"
		},
		{
			filePath: "collector/connections/$connectionId/tags/$tagIndex/custom-settings.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/$tagIndex/custom-settings",
			lazy: !1,
			staticData: { title: "Custom Settings" }
		},
		{
			filePath: "collector/connections/$connectionId/tags/$tagIndex/custom-settings.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/$tagIndex/custom-settings",
			lazy: !0,
			componentName: "ConnectionTagCustomSettings"
		},
		{
			filePath: "collector/connections/$connectionId/tags/$tagIndex/replicators.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/$tagIndex/replicators",
			lazy: !1,
			staticData: { title: "Replicators" }
		},
		{
			filePath: "collector/connections/$connectionId/tags/$tagIndex/replicators.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/tags/$tagIndex/replicators",
			lazy: !0,
			componentName: "ConnectionTagReplicators"
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/_layout.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger",
			lazy: !1,
			staticData: { title: "Condition Triggers" }
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/_layout.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger",
			lazy: !0,
			componentName: "ConfigurationConnectionConditionTriggersLayout"
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/index.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger/",
			lazy: !1,
			staticData: { title: "Condition Triggers" }
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/index.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger/",
			lazy: !0,
			componentName: "ConnectionConditionTriggersIndexRedirect"
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/$triggerIndex/_layout.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger/$triggerIndex",
			lazy: !1,
			staticData: { title: "Condition Trigger" }
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/$triggerIndex/_layout.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger/$triggerIndex",
			lazy: !0,
			componentName: "ConfigurationConnectionConditionTriggersContentLayout"
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/$triggerIndex/index.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger/$triggerIndex/",
			lazy: !1,
			redirect: {
				to: `${e}/collector/connections/$connectionId/condition-trigger/$triggerIndex/configuration`,
				params: "{ id: params.id, connectionId: params.connectionId, triggerIndex: params.triggerIndex }"
			}
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/$triggerIndex/configuration.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger/$triggerIndex/configuration",
			lazy: !1,
			staticData: { title: "Configuration" }
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/$triggerIndex/configuration.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger/$triggerIndex/configuration",
			lazy: !0,
			componentName: "ConnectionTriggerConfiguration"
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/$triggerIndex/custom-settings.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger/$triggerIndex/custom-settings",
			lazy: !1,
			staticData: { title: "Custom Settings" }
		},
		{
			filePath: "collector/connections/$connectionId/condition-trigger/$triggerIndex/custom-settings.lazy.tsx",
			routeSuffix: "/collector/connections/$connectionId/condition-trigger/$triggerIndex/custom-settings",
			lazy: !0,
			componentName: "ConnectionTriggerCustomSettings"
		},
		{
			filePath: "edge-bus/_layout.tsx",
			routeSuffix: "/edge-bus",
			lazy: !1,
			staticData: { title: "Edge Bus" }
		},
		{
			filePath: "edge-bus/_layout.lazy.tsx",
			routeSuffix: "/edge-bus",
			lazy: !0,
			componentName: "ConfigurationDetailEdgeBus"
		},
		{
			filePath: "edge-bus/index.tsx",
			routeSuffix: "/edge-bus/",
			lazy: !1,
			redirect: {
				to: `${e}/edge-bus/connections`,
				params: "{ id: params.id }"
			}
		},
		{
			filePath: "edge-bus/settings.tsx",
			routeSuffix: "/edge-bus/settings",
			lazy: !1,
			staticData: { title: "Settings" }
		},
		{
			filePath: "edge-bus/settings.lazy.tsx",
			routeSuffix: "/edge-bus/settings",
			lazy: !0,
			componentName: "EdgeBusSettingsTab"
		},
		{
			filePath: "edge-bus/connections/_layout.tsx",
			routeSuffix: "/edge-bus/connections",
			lazy: !1,
			staticData: { title: "Connections" }
		},
		{
			filePath: "edge-bus/connections/_layout.lazy.tsx",
			routeSuffix: "/edge-bus/connections",
			lazy: !0,
			componentName: "EdgeBusConnectionsLayout"
		},
		{
			filePath: "edge-bus/connections/index.tsx",
			routeSuffix: "/edge-bus/connections/",
			lazy: !1,
			staticData: { title: "Connections" }
		},
		{
			filePath: "edge-bus/connections/index.lazy.tsx",
			routeSuffix: "/edge-bus/connections/",
			lazy: !0,
			componentName: "EdgeBusConnectionsIndexRedirect"
		},
		{
			filePath: "edge-bus/connections/$connectionIndex/index.tsx",
			routeSuffix: "/edge-bus/connections/$connectionIndex/",
			lazy: !1,
			staticData: { title: "Connection" }
		},
		{
			filePath: "edge-bus/connections/$connectionIndex/index.lazy.tsx",
			routeSuffix: "/edge-bus/connections/$connectionIndex/",
			lazy: !0,
			componentName: "EdgeBusConnectionsSettings"
		},
		{
			filePath: "local-storage/_layout.tsx",
			routeSuffix: "/local-storage",
			lazy: !1,
			staticData: { title: "Local Storage" }
		},
		{
			filePath: "local-storage/_layout.lazy.tsx",
			routeSuffix: "/local-storage",
			lazy: !0,
			componentName: "LocalStorageLayout"
		},
		{
			filePath: "local-storage/index.tsx",
			routeSuffix: "/local-storage/",
			lazy: !1,
			staticData: { title: "Local Storage" }
		},
		{
			filePath: "local-storage/index.lazy.tsx",
			routeSuffix: "/local-storage/",
			lazy: !0,
			componentName: "LocalStorageAutoSelect"
		},
		{
			filePath: "local-storage/$databaseId/_layout.tsx",
			routeSuffix: "/local-storage/$databaseId",
			lazy: !1,
			staticData: { title: "Local Storage" }
		},
		{
			filePath: "local-storage/$databaseId/_layout.lazy.tsx",
			routeSuffix: "/local-storage/$databaseId",
			lazy: !0,
			componentName: "LocalStorageContentLayout"
		},
		{
			filePath: "local-storage/$databaseId/index.tsx",
			routeSuffix: "/local-storage/$databaseId/",
			lazy: !1,
			redirect: {
				to: `${e}/local-storage/$databaseId/settings`,
				params: "{ id: params.id, databaseId: params.databaseId }"
			}
		},
		{
			filePath: "local-storage/$databaseId/buckets.tsx",
			routeSuffix: "/local-storage/$databaseId/buckets",
			lazy: !1,
			staticData: { title: "Buckets" }
		},
		{
			filePath: "local-storage/$databaseId/buckets.lazy.tsx",
			routeSuffix: "/local-storage/$databaseId/buckets",
			lazy: !0,
			componentName: "LocalStorageBucketsRoute"
		},
		{
			filePath: "local-storage/$databaseId/settings.tsx",
			routeSuffix: "/local-storage/$databaseId/settings",
			lazy: !1,
			staticData: { title: "Settings" }
		},
		{
			filePath: "local-storage/$databaseId/settings.lazy.tsx",
			routeSuffix: "/local-storage/$databaseId/settings",
			lazy: !0,
			componentName: "LocalStorageSettingsRoute"
		},
		{
			filePath: "local-storage/$databaseId/custom-settings.tsx",
			routeSuffix: "/local-storage/$databaseId/custom-settings",
			lazy: !1,
			staticData: { title: "Custom Settings" }
		},
		{
			filePath: "local-storage/$databaseId/custom-settings.lazy.tsx",
			routeSuffix: "/local-storage/$databaseId/custom-settings",
			lazy: !0,
			componentName: "LocalStorageCustomSettingsRoute"
		},
		{
			filePath: "replicator/_layout.tsx",
			routeSuffix: "/replicator",
			lazy: !1,
			staticData: { title: "Replicator" }
		},
		{
			filePath: "replicator/_layout.lazy.tsx",
			routeSuffix: "/replicator",
			lazy: !0,
			componentName: "ReplicatorLayout"
		},
		{
			filePath: "replicator/index.tsx",
			routeSuffix: "/replicator/",
			lazy: !1,
			staticData: { title: "Replicator" }
		},
		{
			filePath: "replicator/index.lazy.tsx",
			routeSuffix: "/replicator/",
			lazy: !0,
			componentName: "ReplicatorAutoSelect"
		},
		{
			filePath: "replicator/$replicatorIndex/index.tsx",
			routeSuffix: "/replicator/$replicatorIndex/",
			lazy: !1,
			staticData: { title: "Replicator" }
		},
		{
			filePath: "replicator/$replicatorIndex/index.lazy.tsx",
			routeSuffix: "/replicator/$replicatorIndex/",
			lazy: !0,
			componentName: "ReplicatorSettings"
		},
		{
			filePath: "syncer/_layout.tsx",
			routeSuffix: "/syncer",
			lazy: !1,
			staticData: { title: "Syncer" }
		},
		{
			filePath: "syncer/_layout.lazy.tsx",
			routeSuffix: "/syncer",
			lazy: !0,
			componentName: "SyncerLayout"
		},
		{
			filePath: "syncer/index.tsx",
			routeSuffix: "/syncer/",
			lazy: !1,
			redirect: {
				to: `${e}/syncer/destinations`,
				params: "{ id: params.id }"
			}
		},
		{
			filePath: "syncer/advanced.tsx",
			routeSuffix: "/syncer/advanced",
			lazy: !1,
			staticData: { title: "Advanced" }
		},
		{
			filePath: "syncer/advanced.lazy.tsx",
			routeSuffix: "/syncer/advanced",
			lazy: !0,
			componentName: "SyncerAdvanced"
		},
		{
			filePath: "syncer/destinations/_layout.tsx",
			routeSuffix: "/syncer/destinations",
			lazy: !1,
			staticData: { title: "Destinations" }
		},
		{
			filePath: "syncer/destinations/_layout.lazy.tsx",
			routeSuffix: "/syncer/destinations",
			lazy: !0,
			componentName: "SyncerDestinationsLayout"
		},
		{
			filePath: "syncer/destinations/index.tsx",
			routeSuffix: "/syncer/destinations/",
			lazy: !1,
			staticData: { title: "Destinations" }
		},
		{
			filePath: "syncer/destinations/index.lazy.tsx",
			routeSuffix: "/syncer/destinations/",
			lazy: !0,
			componentName: "SyncerDestinationsIndexRedirect"
		},
		{
			filePath: "syncer/destinations/$destinationId/index.tsx",
			routeSuffix: "/syncer/destinations/$destinationId/",
			lazy: !1,
			staticData: { title: "Destination" }
		},
		{
			filePath: "syncer/destinations/$destinationId/index.lazy.tsx",
			routeSuffix: "/syncer/destinations/$destinationId/",
			lazy: !0,
			componentName: "SyncerDestinationDetail"
		},
		{
			filePath: "triggers/_layout.tsx",
			routeSuffix: "/triggers",
			lazy: !1,
			staticData: { title: "Triggers" }
		},
		{
			filePath: "triggers/_layout.lazy.tsx",
			routeSuffix: "/triggers",
			lazy: !0,
			componentName: "ConfigurationDetailTriggers"
		},
		{
			filePath: "triggers/index.tsx",
			routeSuffix: "/triggers/",
			lazy: !1,
			staticData: { title: "Triggers" }
		},
		{
			filePath: "triggers/$triggerIndex/index.tsx",
			routeSuffix: "/triggers/$triggerIndex/",
			lazy: !1,
			staticData: { title: "Trigger" }
		},
		{
			filePath: "triggers/$triggerIndex/index.lazy.tsx",
			routeSuffix: "/triggers/$triggerIndex/",
			lazy: !0,
			componentName: "TriggerDetailRoute"
		}
	];
}
//#endregion
//#region src/code-route-factory.ts
function o(e) {
	let t = e.replace(/^\/+/, "").replace(/\/+$/, "");
	return t ? t.split("/").filter(Boolean) : [];
}
function s(e, t) {
	let n = e.get(t);
	if (n) return n;
	let r = {
		segment: t,
		children: /* @__PURE__ */ new Map()
	};
	return e.set(t, r), r;
}
function c(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of a(e)) {
		let e = t.get(n.routeSuffix);
		(!e || e.lazy && !n.lazy) && t.set(n.routeSuffix, n);
	}
	return Array.from(t.values()).sort((e, t) => {
		let n = o(e.routeSuffix).length, r = o(t.routeSuffix).length;
		return n === r ? e.routeSuffix.localeCompare(t.routeSuffix) : n - r;
	});
}
function l(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of a(e)) n.lazy && n.componentName && t.set(n.routeSuffix, n.componentName);
	return t;
}
function u(e) {
	let t = /* @__PURE__ */ new Map(), n;
	for (let r of e) {
		let e = o(r.routeSuffix), i = r.routeSuffix.endsWith("/");
		if (e.length === 0 && i) {
			n = r;
			continue;
		}
		let a = t, c;
		for (let t of e) c = s(a, t), a = c.children;
		c && (i ? c.indexDefinition = r : c.routeDefinition = r);
	}
	return {
		rootChildren: t,
		rootIndex: n
	};
}
function d(e, t) {
	let n = Array.from(t.matchAll(/\$([A-Za-z0-9_]+)/g)).map((e) => e[1]);
	if (n.length === 0) return;
	let r = {};
	for (let t of n) t in e && (r[t] = e[t]);
	return r;
}
function f(e, t, n) {
	let r = e.componentName ?? t.get(e.routeSuffix);
	if (!r) return;
	let a, o = () => (a ||= n(r), a);
	function s(t) {
		let n = o();
		if (!n) throw Error(`[@vintecc/config-editor] Unable to resolve component "${r}" for ${e.routeSuffix}`);
		return i(n, t ?? null);
	}
	return s.preload = () => o()?.preload?.(), s;
}
var p = 20;
function m(e) {
	return ({ params: t }) => {
		let n = d(t, e.to);
		throw r(n ? {
			to: e.to,
			params: n,
			replace: !0
		} : {
			to: e.to,
			replace: !0
		});
	};
}
function h(e, n, r, i, a) {
	let o = f(n, i, a);
	return t({
		getParentRoute: r,
		path: e,
		staticData: n.staticData,
		component: o,
		loader: n.redirect ? m(n.redirect) : void 0
	});
}
function g(e, n, r, i, a = 0) {
	let o = [];
	for (let s of e.values()) {
		let e = s.routeDefinition, c = e ? h(s.segment, e, n, r, i) : t({
			getParentRoute: n,
			path: s.segment
		}), l = a < p ? g(s.children, () => c, r, i, a + 1) : [];
		if (!s.indexDefinition && l.length === 0) {
			o.push(c);
			continue;
		}
		let u = [];
		s.indexDefinition && u.push(h("/", s.indexDefinition, () => c, r, i)), u.push(...l), c.addChildren(u), o.push(c);
	}
	return o;
}
function _(e) {
	let t = e.basePath.replace(/\/+$/, ""), n = c(t), r = l(t), { rootChildren: i, rootIndex: a } = u(n), o = g(i, e.getParentRoute, r, e.resolveComponent);
	return a && o.unshift(h("/", a, e.getParentRoute, r, e.resolveComponent)), o;
}
//#endregion
//#region src/code-route-components.ts
async function v(e, t) {
	let n = (await e())[t];
	if (!n) throw Error(`[@vintecc/config-editor] Unable to load component export "${t}"`);
	return { default: n };
}
function y(e, t) {
	return n(() => v(e, t));
}
var b = () => import("./general-CRcczR6K.js").then((e) => e.t), x = () => import("./variables-Cfq5ZlNc.js").then((e) => e.t), S = () => import("./cloud-manager-BVQtlr4Y.js").then((e) => e.t), C = () => import("./ads-router-D8dej0YK.js").then((e) => e.t), w = () => import("./analytics-CBJbrO4f.js").then((e) => e.t), T = () => import("./collector-Dfjqo4N8.js").then((e) => e.t), E = () => import("./edge-bus-C0tnRTk_.js").then((e) => e.t), D = () => import("./local-storage-C6yJdMyp.js").then((e) => e.t), O = () => import("./replicator-BqoI05Nb.js").then((e) => e.t), k = () => import("./syncer-jHlitA4m.js").then((e) => e.t), A = () => import("./triggers-BYaLx25O.js").then((e) => e.t), j = {
	AnalyticsSettings: y(w, "AnalyticsSettings"),
	AnalyticsTriggers: y(w, "AnalyticsTriggers"),
	CollectorLayout: y(T, "CollectorLayout"),
	CollectorSettings: y(T, "CollectorSettings"),
	ConfigurationConnectionConditionTriggersContentLayout: y(T, "ConfigurationConnectionConditionTriggersContentLayout"),
	ConfigurationConnectionConditionTriggersLayout: y(T, "ConfigurationConnectionConditionTriggersLayout"),
	ConfigurationConnectionDetail: y(T, "ConfigurationConnectionDetail"),
	ConfigurationConnectionTagsContentLayout: y(T, "ConfigurationConnectionTagsContentLayout"),
	ConfigurationConnectionTagsLayout: y(T, "ConfigurationConnectionTagsLayout"),
	ConfigurationDetailAdsRouter: y(C, "ConfigurationDetailAdsRouter"),
	ConfigurationDetailAnalytics: y(w, "ConfigurationDetailAnalytics"),
	ConfigurationDetailCloudManager: y(S, "ConfigurationDetailCloudManager"),
	ConfigurationDetailEdgeBus: y(E, "ConfigurationDetailEdgeBus"),
	ConfigurationDetailGeneral: y(b, "ConfigurationDetailGeneral"),
	ConfigurationDetailTriggers: y(A, "ConfigurationDetailTriggers"),
	ConfigurationDetailVariables: y(x, "ConfigurationDetailVariables"),
	ConnectionConditionTriggersIndexRedirect: y(T, "ConnectionConditionTriggersIndexRedirect"),
	ConnectionConfiguration: y(T, "ConnectionConfiguration"),
	ConnectionCustomSettings: y(T, "ConnectionCustomSettings"),
	ConnectionMeasurementConfiguration: y(T, "ConnectionMeasurementConfiguration"),
	ConnectionMeasurementCustomSettings: y(T, "ConnectionMeasurementCustomSettings"),
	ConnectionMeasurementsContentLayout: y(T, "ConnectionMeasurementsContentLayout"),
	ConnectionMeasurementsIndexRedirect: y(T, "ConnectionMeasurementsIndexRedirect"),
	ConnectionMeasurementsLayout: y(T, "ConnectionMeasurementsLayout"),
	ConnectionMeasurementVariables: y(T, "ConnectionMeasurementVariables"),
	ConnectionsOverview: y(T, "ConnectionsOverview"),
	ConnectionTagConfiguration: y(T, "ConnectionTagConfiguration"),
	ConnectionTagCustomSettings: y(T, "ConnectionTagCustomSettings"),
	ConnectionTagReplicators: y(T, "ConnectionTagReplicators"),
	ConnectionTagsIndexRedirect: y(T, "ConnectionTagsIndexRedirect"),
	ConnectionTriggerConfiguration: y(T, "ConnectionTriggerConfiguration"),
	ConnectionTriggerCustomSettings: y(T, "ConnectionTriggerCustomSettings"),
	EdgeBusConnectionsIndexRedirect: y(E, "EdgeBusConnectionsIndexRedirect"),
	EdgeBusConnectionsLayout: y(E, "EdgeBusConnectionsLayout"),
	EdgeBusConnectionsSettings: y(E, "EdgeBusConnectionsSettings"),
	EdgeBusSettingsTab: y(E, "EdgeBusSettingsTab"),
	LocalStorageAutoSelect: y(D, "LocalStorageAutoSelect"),
	LocalStorageBucketsRoute: y(D, "LocalStorageBucketsRoute"),
	LocalStorageContentLayout: y(D, "LocalStorageContentLayout"),
	LocalStorageCustomSettingsRoute: y(D, "LocalStorageCustomSettingsRoute"),
	LocalStorageLayout: y(D, "LocalStorageLayout"),
	LocalStorageSettingsRoute: y(D, "LocalStorageSettingsRoute"),
	ReplicatorAutoSelect: y(O, "ReplicatorAutoSelect"),
	ReplicatorLayout: y(O, "ReplicatorLayout"),
	ReplicatorSettings: y(O, "ReplicatorSettings"),
	SyncerAdvanced: y(k, "SyncerAdvanced"),
	SyncerDestinationDetail: y(k, "SyncerDestinationDetail"),
	SyncerDestinationsIndexRedirect: y(k, "SyncerDestinationsIndexRedirect"),
	SyncerDestinationsLayout: y(k, "SyncerDestinationsLayout"),
	SyncerLayout: y(k, "SyncerLayout"),
	TriggerDetailRoute: y(A, "TriggerDetailRoute")
};
function M(e) {
	return j[e];
}
//#endregion
//#region src/code-routes.ts
function N(e) {
	return _({
		...e,
		resolveComponent: e.resolveComponent ?? M
	});
}
//#endregion
export { e as ConfigurationDetail, N as createConfigEditorCodeRoutes, M as resolveConfigEditorRouteComponent };

//# sourceMappingURL=code-routes.js.map